import { AlmaSummary } from 'components/AlmaSummary/AlmaSummary'
import type { TInsectId, TPropertyId, TRegionId } from 'stores/fieldAssetStore/helperTypes'
import { getSummaryParams as getDegreeDaysSummaryParams } from './insectDegreeDaySummary'
import { getSummaryParams as getTrapSummaryParams } from './insectTrapSummary'

export const AlmaSummaries = ({
  insectId,
  propertyId,
  regionId,
}: {
  insectId: TInsectId
  propertyId?: TPropertyId | null
  regionId?: TRegionId | null
}) => {
  return (
    <AlmaSummary
      context="details-panel"
      summaries={{
        [`insectTrapsSummary_${insectId}`]: getTrapSummaryParams({ insectId, propertyId, regionId }),
        [`insectDegreeDaysSummary_${insectId}`]: getDegreeDaysSummaryParams({
          insectId,
          propertyId,
          regionId,
        }),
      }}
    />
  )
}
